module.exports = __webpack_public_path__ + "assets/img/08.3a00240f.png";